require('../../vendor/modernizr');
require('jquery-match-height');

function visible(el, partial, hidden, direction, container) {
    var $t = $(el),
        isContained = typeof container !== "undefined" && container !== null,
        $w = isContained ? $(container) : $(window),
        wPosition = isContained ? $w.position() : 0,
        t = $t.get(0),
        vpWidth = $w.outerWidth(),
        vpHeight = $w.outerHeight(),
        direction = direction ? direction : "both",
        clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;

    if (typeof t.getBoundingClientRect === "function") {
        // Use this native browser method, if available.
        var rec = t.getBoundingClientRect(),
            tViz = isContained ?
            rec.top - wPosition.top >= 0 &&
            rec.top < vpHeight + wPosition.top :
            rec.top >= 0 && rec.top < vpHeight,
            bViz = isContained ?
            rec.bottom - wPosition.top > 0 &&
            rec.bottom <= vpHeight + wPosition.top :
            rec.bottom > 0 && rec.bottom <= vpHeight,
            lViz = isContained ?
            rec.left - wPosition.left >= 0 &&
            rec.left < vpWidth + wPosition.left :
            rec.left >= 0 && rec.left < vpWidth,
            rViz = isContained ?
            rec.right - wPosition.left > 0 &&
            rec.right < vpWidth + wPosition.left :
            rec.right > 0 && rec.right <= vpWidth,
            vVisible = partial ? tViz || bViz : tViz && bViz,
            hVisible = partial ? lViz || rViz : lViz && rViz;

        if (direction === "both") return clientSize && vVisible && hVisible;
        else if (direction === "vertical") return clientSize && vVisible;
        else if (direction === "horizontal") return clientSize && hVisible;
    } else {
        var viewTop = isContained ? 0 : wPosition,
            viewBottom = viewTop + vpHeight,
            viewLeft = $w.scrollLeft(),
            viewRight = viewLeft + vpWidth,
            position = $t.position(),
            _top = position.top,
            _bottom = _top + $t.height(),
            _left = position.left,
            _right = _left + $t.width(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom,
            compareLeft = partial === true ? _right : _left,
            compareRight = partial === true ? _left : _right;

        if (direction === "both")
            return (!!clientSize &&
                (compareBottom <= viewBottom && compareTop >= viewTop) &&
                (compareRight <= viewRight && compareLeft >= viewLeft)
            );
        else if (direction === "vertical")
            return (!!clientSize &&
                (compareBottom <= viewBottom && compareTop >= viewTop)
            );
        else if (direction === "horizontal")
            return (!!clientSize &&
                (compareRight <= viewRight && compareLeft >= viewLeft)
            );
    }
}

module.exports = {
    matchHeight: function ($els, options) {
        return $.fn.matchHeight.call($els, options);
    },
    scrollToPageTop: function ($el) {
        if ($el) {
          $($el).animate({
              scrollTop: '0px'
          }, 300);
        } else {
          $('html, body').animate({
              scrollTop: '0px'
          }, 300);
        }
    },
    isAnyPartElementVisible: function (el) {
        return visible(el, true);
    },
    isAllElementVisible: function (el) {
        return visible(el, false);
    },
    isElementVisible: function (el) {
        return visible(el);
    },
    isPhone: function () {
        return Modernizr.mq('screen and (max-width: 767px)');
    },
    isTablet: function () {
        return (
            Modernizr.mq('screen and (min-width: 768px) and (max-width: 991px)') ||
            !Modernizr.mq('only all')
        );
    },
    isAccessoriesKioskWidth: function () {
      return (
          Modernizr.mq('screen and (min-width: 992px) and (max-width: 1080px)') ||
          !Modernizr.mq('only all')
      );
    },
    isAccessoriesKioskHeight: function () {
      return (
        Modernizr.mq('screen and (min-height: 1600px) and (max-height: 1920px)')
      );
    },
    isDesktop: function () {
        return (
            Modernizr.mq('screen and (min-width: 1082px) and (max-width: 1199px)') ||
            !Modernizr.mq('only all')
        );
    },
    isLargeDesktop: function () {
        return (
            Modernizr.mq('screen and (min-width: 1200px) and (max-width: 1599px)') ||
            !Modernizr.mq('only all')
        );
    },
    isExtraLargeDesktop: function () {
        return (
            Modernizr.mq('screen and (min-width: 1600px)') ||
            !Modernizr.mq('only all')
        );
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/utils/ui.js
 **/